var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66968 18.1953V18.6755C9.66968 19.2944 9.91552 19.8879 10.3531 20.3255C10.7907 20.7631 11.3843 21.009 12.0031 21.009H12.005C12.6241 21.0092 13.218 20.7635 13.656 20.3259C14.0939 19.8883 14.3401 19.2946 14.3404 18.6755V18.1953",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5826 18.1953C18.646 18.1953 19.5081 17.3332 19.5081 16.2698V16.2698C19.5077 15.7296 19.2932 15.2116 18.9116 14.8292L17.6323 13.5509V9.7543C17.6323 6.6464 15.1129 4.12695 12.005 4.12695V4.12695C8.89706 4.12695 6.37761 6.6464 6.37761 9.7543V13.5509L5.09833 14.8292C4.71675 15.2116 4.50226 15.7296 4.50183 16.2698V16.2698C4.50183 17.3332 5.3639 18.1953 6.42732 18.1953H17.5826V18.1953Z",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0305 3.00146L20.0297 4.33533",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0096 9.00363H21.03",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97949 3.00146L3.98033 4.33533",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00037 9.00363H2.97989",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9fdf085df25c17b3dd62c0c989ee9a34.svg";
export { ForwardRef as ReactComponent };